import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { themr } from 'react-css-themr';
import { Helmet } from 'react-helmet';
import ContactVG from '../../local-components/about/ContactVG';

@themr('AboutVG')
export default class ContactUs extends Component {
    /* eslint-disable react/forbid-prop-types */
    static propTypes = {
        theme: PropTypes.object,
    };
    /* eslint-enable react/forbid-prop-types */

    static defaultProps = {
        theme: {},
    };

    render() {
        const { theme } = this.props;

        return (
            <div className={theme.root}>
                <Helmet title="Kontakt oss" />

                <main className={theme.contentContainer} role="main" id="main">
                    <span className="lp_is_start" style={{ width: '1px', height: '1px' }} />
                    <ContactVG theme={theme} />
                    <span className="lp_is_end" style={{ width: '1px', height: '1px' }} />
                </main>
            </div>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./src/screens/contact/index.js
 **/